import {
  CompactDriverType,
  DriverType,
} from '../../../interfaces/delivery-company/drivers';
import { IconWithText } from './components';
import MopedIcon from '@mui/icons-material/Moped';

interface DriverWithIconProps {
  driver?: CompactDriverType | null;
  centered?: boolean;
  showPhone?: boolean;
}
export const DriverWithIcon = ({
  driver,
  centered,
  showPhone,
}: DriverWithIconProps) => {
  if (!driver) return <></>;
  return (
    <div style={{ width: '100%', marginTop: 0 }}>
      <IconWithText centered={centered}>
        {' '}
        <MopedIcon color="primary" />
        <span>{driver.name}</span> {showPhone && <>{driver.phone_number}</>}
      </IconWithText>
    </div>
  );
};
